import React, { type ReactElement } from 'react';

import IconSquareQuote from '@components/Images/Rebranding/IconSquareQuote';

import { ProSubscriberNotBotProps } from './interfaces';

const ProQuote = ({ isProSubscriberNotBot }: ProSubscriberNotBotProps): ReactElement => {
  return (
    <div className="mt-48 border-0 border-t border-solid border-grayscale-beige pt-48 md:px-72">
      {isProSubscriberNotBot && (
        <h2 className="mx-auto my-0 max-w-[660px] text-center font-suisse-works text-headline-xs text-primary-black sm:mb-24 sm:text-headline-md lg:max-w-full">
          Why Industry Leaders Rely on Pro
        </h2>
      )}
      <div className="m-auto flex flex-col sm:flex-row sm:items-start md:max-w-[774px]">
        <IconSquareQuote className="w-[68px] shrink-0 text-grayscale-beige sm:mt-8 md:w-[106px] dark:bg-transparent dark:text-pro-gold" />
        <div className="mt-8 sm:ml-32">
          <blockquote className="m-0 font-suisse-intl text-body-lg text-grayscale-charcoal">
            The Information is one of the few trusted sources of tech news that I reference on a
            daily basis, sometimes even sourcing opportunities based on your team’s reporting. I
            know I speak on behalf of my firm when I say: all of us read The Information as the most
            reliable source of new venture news, development from other investors and incumbents and
            tech policy.”
          </blockquote>
          <cite className="m-0 mt-8 block font-suisse-screen text-byline-md not-italic text-grayscale-gray">
            <span className="text-byline-lg font-bold">Vinod Khosla</span> | Founder, Khosla
            Ventures
          </cite>
        </div>
      </div>
    </div>
  );
};

export default ProQuote;
